import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignVerticalCentre20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowAlignVerticalCentre20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11.416 9.6a.65.65 0 0 0-.003.806l2.564 3.205a.641.641 0 0 0 1.001-.8l-1.735-2.17h4.443a.641.641 0 0 0 0-1.282H13.25l1.731-2.164a.64.64 0 1 0-1-.8zM9.353 4.206c0-.34.287-.616.64-.616a.63.63 0 0 1 .642.616v11.588c0 .34-.287.616-.641.616a.63.63 0 0 1-.641-.616zm-4.24 9.485a.64.64 0 0 0 .9-.1l2.565-3.196a.64.64 0 0 0-.066-.87l-2.505-3.13a.641.641 0 1 0-1.001.8l1.73 2.164H2.302a.641.641 0 0 0 0 1.282H6.74l-1.726 2.152a.64.64 0 0 0 .1.898"
            />
        </svg>
    );
}
export default memo(IconArrowAlignVerticalCentre20);
